export class IndexedQueue<T extends {key: string}> {
  private map = new Map<string, T>();
  private queue: string[] = [];

  constructor() {}

  get last(): T | undefined {
    const key = this.queue.at(-1);

    if (!key) return undefined;

    return this.map.get(key);
  }

  get length() {
    return this.queue.length;
  }

  at(index: number): T | undefined {
    const key = this.queue.at(index);

    if (!key) return;

    return this.map.get(key);
  }

  has(key: string): boolean {
    return this.map.has(key);
  }

  enqueue(item: T) {
    if (this.map.has(item.key)) {
      this.map.set(item.key, item);

      return;
    }

    this.map.set(item.key, item);
    this.queue.push(item.key);
  }

  dequeue(key: string): T | undefined {
    if (!this.map.has(key)) return undefined;

    const item = this.map.get(key);

    this.map.delete(key);
    this.queue = this.queue.filter(q => q !== key);

    return item;
  }
}
